<template>
  <!-- Footer -->
  <footer class="page-footer font-small blue pt-4">
    <div class="container-fluid text-center text-md-left">
      <div class="row">
        <div class="col-md-12 mt-md-0 mt-12"></div>
        <hr class="clearfix w-100 d-md-none pb-3" />
        <a href="https://www.facebook.com/Everything-Cheer-and-Dance-101558791557537" target="_blank">
          <img :src="require('@/assets/f_logo_RGB-White_250.png')" height="50px" />
        </a>
        <div class="col-md-12 mb-md-0 mb-12" style="padding-top:20px;">
          <h5>Links</h5>
          <ul class="list-unstyled">
            <li class="footer-link">
              <a class="nav-link pointer" @click="goHome">Home</a>
            </li>
            <li class="footer-link">
              <a class="nav-link pointer" @click="goListings">My Listings</a>
            </li>
            <li class="footer-link">
              <a class="nav-link pointer" @click="goRegister">Register</a>
            </li>
            <li class="footer-link">
              <a class="nav-link pointer" @click="goLogin">Login</a>
            </li>
            <li class="footer-link">
              <router-link to="/privacyPolicy">
                <a class="nav-link pointer" >Privacy Policy</a>
              </router-link>
            </li>
            <li class="footer-link">
              <router-link to="/faq">
                <a class="nav-link pointer" >FAQ</a>
              </router-link>
            </li>
            <li class="footer-link">
              <router-link to="/announcements">
                <a class="nav-link pointer" >Announcements</a>
              </router-link>
            </li>
            <li class="footer-link">
              <router-link to="/contact">
                <a class="nav-link pointer" >Contact</a>
              </router-link>
            </li>

          </ul>
        </div>
        <div class="col-sm-12" style="padding-top:20px;">
          <h5>Services</h5>
          <!-- <ul class="list-unstyled"> -->
          <div class="row">
            <div
              class="col-sm-3 col-md-2"
              style="padding:10px;"
              v-for="service in store.state.services"
              :key="service.id"
            >
              <router-link :to="`/feed/${service.slug}`">
                <a class="pointer">{{service.name}}</a>
              </router-link>
            </div>
          </div>
          <!-- </ul> -->
        </div>
      </div>
    </div>
    <div class="footer-copyright text-center py-3" style="color:white">
      © 2020 Copyright
      Everything Cheer & Dance |
      <a href="https://icons8.com/" target="_blank">Icons By Icons8</a>
    </div>
  </footer>
</template>

<script>
import Navigator from "@/router/navigator";
import FooterStore from "@/components/nav/FooterStore";

export default {
  name: "DashboardFooter",
  data() {
    return {
      router: Navigator,
      store: FooterStore
    };
  },
  mounted() {
    this.store.getServices();
  },
  methods: {
    goHome: function() {
      this.router.goHome(this);
    },
    goListings: function() {
      this.router.goListings(this);
    },
    goRegister: function() {
      this.router.goRegister(this);
    },
    goLogin: function() {
      this.router.goLogin(this);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #007bff;
}

.navbar {
  background: #007bff !important;
}

.navbar,
a {
  color: white !important;
}

.pointer {
  cursor: pointer;
}

footer {
  background-color: #192965;
  color: white;
  padding-left: 50px;
  padding-right: 50px;
}

@media (max-width: 768px) {
  .footer-link {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nav/Footer.vue